export default __webpack_public_path__ + "static/media/logo-finanzas.8835c0ce.png";